import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

import type {
  TabType,
} from './types';

const StyledContent = styled.div(({
  theme: {
    tabs,
  },
}) => ({
  display: 'flex',
  gap: tabs.ICON_OFFSET,
}));

export const StyledIcon = styled.div<{
  $isCurrent: boolean;
}>(({
  $isCurrent,

  theme: {
    colors,
    tabs,
  },
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors[$isCurrent ? tabs.ICON_ACTIVE_COLOR : tabs.ICON_INACTIVE_COLOR],
}));

const StyledLabel = styled.div({
  flex: 1,
});

export type TabContentProps = {
  isCurrent: boolean;
  label: ReactNode;
  tab: TabType;
};

export function TabContent({
  isCurrent,
  label,
  tab: {
    renderIcon,
  },
}: TabContentProps): ReactElement {
  return (
    <StyledContent>
      {renderIcon && (
        <StyledIcon
          $isCurrent={isCurrent}
        >
          {renderIcon()}
        </StyledIcon>
      )}

      <StyledLabel>
        {label}
      </StyledLabel>
    </StyledContent>
  );
}
